export default __webpack_public_path__ + "static/mazuis-review-regular-0b9fddb919335715b436f5494a1f085c.woff2";